<template>
<div>
  <el-dialog
        class="fieldSetDialog"
        v-model="dialogfieldSetVisible"
        title="自定义设置"
        append-to-body
        v-loading.fullscreen.lock="fieldSetLoading"
        @close="closeFieldSet"
        width="554px">
      <el-container style="margin-top:10px;display:inline-block;width: 100%;">
        <div class="selectArea">
            <div class="title">导出格式如：</div>
            <div class="showArea">
                <el-input
                type="textarea"
                resize="none"
                :readonly="true"
                placeholder="请选择内容"
                v-model="textareaValue">
                </el-input>
            </div>
        </div>
        <div class="selectArea">
            <div class="title">选择自定义字段</div>
            <div class="showArea">
                <el-scrollbar class="scrollbarArea" style="height:234px;">
                    <el-checkbox-group v-model="checkList" @change="handleCheckedChange">
                        <el-checkbox
                        v-for="(item,i) in fieldDatasArray"
                        :key="i"
                        :label="item.name"></el-checkbox>



                    </el-checkbox-group>
                </el-scrollbar>
            </div>
        </div>
      </el-container>
      <template #footer>
        <div class="footer">
          <el-button size="medium" @click="closeFieldSet">取 消</el-button>
          <el-button type="yeprimary" size="medium" @click="submitFieldSet">确定</el-button>
        </div>
      </template>
  </el-dialog>
</div>
</template>
<script>

export default {
  name: "fieldSet",
  data () {
    return {
      fieldSetLoading: false,//- 附件字段设置显示加载
      dialogfieldSetVisible: false,//- 附件字段设置显示参数
      checkList: [],//- 附件字段设置选择
      textareaValue: '',
      fieldDatasArray: [],//- 字段数据
      submitDatas: [],//- 字段设置名称提交数据
      showFromIndex: 0,//- 之前进入该页面时字段设置序号
      whetherFirst: true,//- 是否第一次进入
      beforeDatas: [],//- 第二次刚进入时的数据
    }

  },
  watch:{
    checkList: {
      handler(){
        console.log("监听checkList");
        let checkList = JSON.parse(JSON.stringify(this.checkList));

        //- 赋值
        this.textareaValue = checkList.join("_");
      },
      deep:true
    }
  },
  components: {

  },
  mounted() {
    console.log("fieldSet启动执行了")
  },
  unmounted(){
    console.log("fieldSet需要销毁");
  },
  methods: {
      //- 选择字段时的数据保存
      handleCheckedChange(val) {
        console.log("handleCheckedChange",val);
        let checkList = JSON.parse(JSON.stringify(this.checkList));
        let fieldDatasArray = JSON.parse(JSON.stringify(this.fieldDatasArray));
        if(checkList.length > 5) {
          let new_checkList = checkList.filter((item,i) => i <= 4);
          console.log("new_checkList",new_checkList)
          this.checkList = new_checkList;
          this.$message.error('最多选择5个字段');
          return;
        }
        this.submitDatas = [];//- 先清空
        checkList.forEach((name)=>{
          // console.log("name",name);
          for (let item of fieldDatasArray){

            // console.log("itemname",item.name);
            if(name === item.name){
              // console.log("相等了=======>",name,"||",item.name);
              this.submitDatas.push(item);
              break;
            }

          }

        })

      },
      //- 打开附件字段设置
      openFieldSet(val,i,selectDatas){
        console.log("val,i,selectDatas",val,i,selectDatas)
        this.dialogfieldSetVisible = true;
        this.fieldSetLoading = false;
        this.showFromIndex = JSON.parse(JSON.stringify(i));
        this.fieldDatasArray = JSON.parse(JSON.stringify(val));
        //- 判断是否是二次渲染
        if(JSON.stringify(selectDatas) != '[]'){
          selectDatas = JSON.parse(JSON.stringify(selectDatas));
          selectDatas.forEach((item)=>{
            this.checkList.push(item.name);
          })
          this.submitDatas = selectDatas;
          this.whetherFirst = false;
          this.beforeDatas = selectDatas;
        }
      },
      //- 关闭附件字段设置
      closeFieldSet(){
        let showFromIndex = JSON.parse(JSON.stringify(this.showFromIndex));
        if(this.whetherFirst === false){
          //- 第二次进入
          this.$parent.SetReturnData(JSON.parse(JSON.stringify(this.beforeDatas)),showFromIndex);
        }else{
          this.$parent.SetReturnData([],showFromIndex);
        }

        this.dialogfieldSetVisible = false;
        this.$parent.fieldSetShow = false;
      },
      //- 提交附件字段设置
      submitFieldSet(){
        let showFromIndex = JSON.parse(JSON.stringify(this.showFromIndex));
        let submitDatas = JSON.parse(JSON.stringify(this.submitDatas));
        this.$parent.SetReturnData(submitDatas,showFromIndex);
        this.dialogfieldSetVisible = false;
        this.$parent.fieldSetShow = false;
      },

  },
}
</script>
<style lang="scss">
.fieldSetDialog {
  .el-dialog {
    .el-dialog__header {
      padding: 15px 17px;
      background:rgba(247,247,247,1);
    }
    .el-dialog__body {
      padding-bottom: 3px;
      .selectArea {
        width: 100%;
        margin-bottom: 10px;
        .title {
          font-size:14px;
          font-weight:bold;
          color:rgba(51,51,51,1);
          margin-bottom: 10px;
        }
        .scrollbarArea {
          background:rgba(255,255,255,1);
          border-radius:4px;
          border:1px solid rgba(229,229,229,1);
          .el-scrollbar__wrap {
            overflow-x: hidden;
          }
          .el-checkbox {
            width: 97%;
            padding-left: 3%;
            height: 40px;
            line-height: 40px;
            .el-checkbox__label {
              width: 92%;
              height: 30px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              display: inline-block;
              margin-top: 6px;
              vertical-align: top;
              line-height: 30px;
            }
          }
        }
      }
    }
    .el-dialog__footer {
      text-align: center;
      padding: 10px 20px 20px;
    }
  }
}
</style>
